import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateApiUrl, corporateHost, eramanApiURL } from "~/Utils";
import { useLargeCardsDocumentDetails } from "./LargeCard.hook";
import { fields } from "./constant";
export const AddEditSpotlightLargecards = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useLargeCardsDocumentDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const SmallCardFormConfig: FormConfig = {
    initialValues: {
      title: dataById
        ? decodeHTML(dataById.payload.title)
        : editData
        ? decodeHTML(editData?.title)
        : "",
      field_homecards_title_ms: dataById
        ? decodeHTML(dataById.payload.field_homecards_title_ms)
        : editData
        ? decodeHTML(editData?.field_homecards_title_ms)
        : "",
      field_homecards_title_zh: dataById
        ? decodeHTML(dataById.payload.field_homecards_title_zh)
        : editData
        ? decodeHTML(editData?.field_homecards_title_zh)
        : "",
      field_homecards_desc_en: dataById
        ? decodeHTML(dataById.payload.field_homecards_desc_en)
        : editData
        ? decodeHTML(editData?.field_homecards_desc_en)
        : "",
      field_homecards_desc_ms: dataById
        ? decodeHTML(dataById.payload.field_homecards_desc_ms)
        : editData
        ? decodeHTML(editData?.field_homecards_desc_ms)
        : "",
      field_homecards_desc_zh: dataById
        ? decodeHTML(dataById.payload.field_homecards_desc_zh)
        : editData
        ? decodeHTML(editData?.field_homecards_desc_zh)
        : "",
      field_large_title_html_en: dataById
        ? decodeHTML(dataById.payload.field_large_title_html_en)
        : editData
        ? decodeHTML(editData?.field_large_title_html_en)
        : "",
      field_large_title_html_ms: dataById
        ? decodeHTML(dataById.payload.field_large_title_html_ms)
        : editData
        ? decodeHTML(editData?.field_large_title_html_ms)
        : "",
      field_home_large_html_zh: dataById
        ? decodeHTML(dataById.payload.field_home_large_html_zh)
        : editData
        ? decodeHTML(editData?.field_home_large_html_zh)
        : "",
      field_homecards_url_en: dataById
        ? decodeHTML(dataById.payload.field_homecards_url_en)
        : editData
        ? decodeHTML(editData?.field_homecards_url_en)
        : "",
      field_homecards_url_ms: dataById
        ? decodeHTML(dataById.payload.field_homecards_url_ms)
        : editData
        ? decodeHTML(editData?.field_homecards_url_ms)
        : "",
      field_homecards_url_zh: dataById
        ? decodeHTML(dataById.payload.field_homecards_url_zh)
        : editData
        ? decodeHTML(editData?.field_homecards_url_zh)
        : "",
      field_homecards_sequence: dataById
        ? decodeHTML(dataById.payload.field_homecards_sequence)
        : editData
        ? decodeHTML(editData?.field_homecards_sequence)
        : "",
      field_homecards_image: decodeHTML([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: dataById?.payload?.field_homecards_image
            ? dataById.payload.field_homecards_image
            : editData?.field_homecards_image || "",
        },
      ]),
    },
    fields: fields.largecards,
  };
  

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data", data);
    let imageKeys: any = ["field_homecards_image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // let descKeys: any = [
    //   "field_homecards_desc_en",
    //   "field_homecards_desc_ms",
    //   "field_homecards_desc_zh",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) {}
    // }

    const payload = {
      action: action,
      method: method,
      module: "Homepage",
      subModule: `spotlightcards_largecards`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Homepage_Spotlight Cards",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Large Cards`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={SmallCardFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get('type')==='update'? `${corporateHost}/api/homepage-large-card/${dataById?.payload?.id || editData?.id}`:`${corporateHost}/api/create/homepage-large-card`, 
            `${query.get("editId") || query.get('type')==='update' ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get('type')==='update' ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Homepage"
      />
    </ContentWrapper>
  );
};
